import _ from "lodash";
import { SizeData } from "components/shipment-review/types";
import { isInErrorState } from "components/shipment-review/helpers/inventory";

const formatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

type getAvailableInventoryOptions = {
    useDisplayInventory: boolean;
    quantity?: number;
    prebook?: boolean;
};

export const getAvailableInventory = (
    sizeData: SizeData,
    { useDisplayInventory, quantity, prebook }: getAvailableInventoryOptions
): string => {
    if (_.isEmpty(sizeData) || prebook) {
        return "";
    }

    const { available, displayQuantity } = sizeData;
    quantity = quantity ?? sizeData.quantity;

    if (displayQuantity?.length) {
        return displayQuantity;
    }

    if (!useDisplayInventory && isInErrorState(available, quantity, prebook)) {
        return formatter.format(available);
    }

    return "";
};
